<template>

    <h3 v-if="hasExperience && showTitle" class="text-black md:text-[1.6rem] sm:text-[1.6rem] font-medium">{{ $t('Experience') }}</h3>

    <div v-if="showAboutSection && hasAboutMe" class="mt-[2.4rem]">
      <TextList
        :list="aboutMe"
        :title="$t('About me')"
        :show-more-content-btn="false"
      />
    </div>

    <div v-if="hasEducation" class="mt-[2.4rem]">
      <TextList
        :list="education"
        :title="$t('Training')"
        :show-more-content-btn="false"
      />
    </div>
    
</template>

<script>

import TextList  from '@/components/form/textList.vue';

export default {
  name: 'WorkExperience',
  components: {
    TextList 
  },
  props: {
    aboutMe: {
      type: Array,
      required: true,
      default: () => [],
    },
    education: {
      type: Array,
      required: true,
      default: () => [],
    },
    showAboutSection: {
      type: Boolean,
      default: true,
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    hasAboutMe() {
      return Array.isArray(this.aboutMe) && this.aboutMe.length > 0;
    },
    hasEducation() {
      return Array.isArray(this.education) && this.education.length > 0;
    },
    hasExperience() {
      return this.hasEducation || (this.showAboutSection && this.hasAboutMe);
    },
  },
}
</script>

<style scoped>



</style>
